import { render, staticRenderFns } from "./Navlink-2023-08-07.vue?vue&type=template&id=2727e244&scoped=true&"
import script from "./Navlink-2023-08-07.vue?vue&type=script&lang=js&"
export * from "./Navlink-2023-08-07.vue?vue&type=script&lang=js&"
import style0 from "./Navlink-2023-08-07.vue?vue&type=style&index=0&id=2727e244&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2727e244",
  null
  
)

export default component.exports